class ImageDimensions {
  constructor(options = {}) {
    const {
      parentContainerSelector,
    } = options;

    this.parentContainerSelector = parentContainerSelector;
  }

  get #parentContainer() {
    return document.querySelector(this.parentContainerSelector);
  }

  get #container() {
    return document.getElementById(this.#dimensionsContainerId);
  }

  get #dimensionsContainerId() {
    return 'image-dimensions-container';
  }

  get #containerStyle() {
    return {
      position: 'absolute',
      right: '10px',
      bottom: '10px',
      color: '#fff',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      padding: '0 5px',
      borderRadius: '5px',
      fontSize: '12px',
      height: '20px',
      lineHeight: '20px',
    };
  }

  dimensions(data) {
    const { width, height } = data || {};
    if (!width || !height) {
      return {
        width: null,
        height: null,
        dimensionsText: '',
      };
    }
    const dimensions = {
      width: Math.round(width),
      height: Math.round(height),
    };

    return {
      ...dimensions,
      dimensionsText: `${dimensions.width}px x ${dimensions.height}px`,
    };
  }

  appendContainer() {
    if (!this.#container) {
      const el = document.createElement('div');
      el.id = this.#dimensionsContainerId;
      // set styles
      Object.entries(this.#containerStyle).forEach(([key, value]) => {
        el.style[key] = value;
      });

      this.#parentContainer?.appendChild(el);
    }
  }

  render(data) {
    const dimensionsContainer = this.#container;
    if (dimensionsContainer) {
      const { dimensionsText } = this.dimensions(data);
      dimensionsContainer.innerText = dimensionsText;
    }
  }
}

export default ImageDimensions;
